import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { updateQoutesStatus, updateQuoteStatusProps } from "@tKgpco/Services/UpdateQuoteStatusService";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type Parameters = updateQuoteStatusProps & HasOnSuccess & HasOnError;
type HandlerType = CustomHandler<Parameters, any>

export const PopulateApiParameter: HandlerType = props => {
    const { Status, QuoteId } = props.parameter;
    props.apiParameter = {
        Status, QuoteId
    };
};

export const UpdateQuoteStatus: HandlerType = async props => {
    try {
        await updateQoutesStatus(props.parameter)
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
}

export const ExecuteOnSuccess: HandlerType = props => {
    if (props.parameter?.onSuccess) {
        props.parameter.onSuccess();
    }
}


export const chain = [PopulateApiParameter, UpdateQuoteStatus, ExecuteOnSuccess];

const updateQuoteStatus = createHandlerChainRunner(chain, "UpdateQuoteStatus");
export default updateQuoteStatus;